import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const storageTypes = ['upload', 'private', 'authenticated'] as const
export const StorageTypeSchema = z.enum(storageTypes)
export type StorageType = ZodSimplify<typeof StorageTypeSchema>
